import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DepartmentsService {
  getParishRegion() {
    throw new Error("Method not implemented.");
  }
  getOutstationName() {
    throw new Error("Method not implemented.");
  }
  getZone() {
    throw new Error("Method not implemented.");
  }
  getCommunityLocation() {
    throw new Error("Method not implemented.");
  }
  
  getDiocese():any {
    throw new Error('Method not implemented.');
  }
  getStages() {
    throw new Error('Method not implemented.');
  }

  constructor(private http: HttpClient) { }

  // /p2p/departments/add
  
  addDepartment(data: any): Observable<any> {
    return this.http.post(
      `${environment.baseUrl}` + "/p2p/departments/add",
      data
    );
  }
  getDepartmentById(id: number): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/p2p/departments/find/${id}`
    );
  }
  updateDepartment(details: any): Observable<any> {
    return this.http.put<any>(
      `${environment.baseUrl}` + `/p2p/departments/edit`,
      details
    );
  }
  deleteDepartment(id: number): Observable<any> {
    return this.http.delete(
      `${environment.baseUrl}/p2p/departments/delete/${id}`,
      { responseType: "text" }
    );
  }
    deleteProfile(id: number): Observable<any> {
    return this.http.delete(
      `${environment.baseUrl}/api/v1/AppUser/deleteProfile/${id}`,
      { responseType: "text" }
    );
  }


  public uploadImage(profileDetails): Observable<{ message: string }> {
    const updateUserimageUrl = `${environment.baseUrl}/api/v1/AppUser/update/image`;

    return this.http.put<{ message: string }>(
      updateUserimageUrl,
      profileDetails
    );
  }
  
  getDepartments(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/p2p/departments/view`
    );
  }  
  getChurch(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/get/all`
    );
  }  getCommunity(parishId: any): Observable<any> {
    return this.http.get<any[]>(
  
      `${environment.baseUrl}/api/v1/Community/fetch/communities/${parishId}`
      
    );
  } 


   getCommunityById(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/api/v1/outstation/outStation/${params}/communities`
    );
  }
   getGroupsById(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/Groups/get/by/outStationId/${params}`
    );
  } 
  getFamilyById(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/outstation/outstation/${params}`
    );
  }
  //   findById(params: any): Observable<any> {
  //   return this.http.get<any[]>(
  //     `${environment.baseUrl}/api/v1/Community/get/by/id`,{ params: params, }
  //   );
  // } 
  getOutstation(parishId: any): Observable<any> {
    const stationsUrl = `${environment.baseUrl}/api/v1/outstation/fetch/all/${parishId}`;

    return this.http.get<any[]>(stationsUrl);
  }

  
  getCounties(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/location/counties/all`
    );
  }
  getSubCounties(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/location/subcounties/all`
    );
  }  getcons(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/location/constituencies/all`
    );
  }
  getwards(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/location/wards/all`
    );
  }
  getvillage(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/location/village/all`
    );
  }

  
  getFamily(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/Family/get/all`
    );
  } 
  getFamilies(parishId: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/Family/fetch/families/${parishId}`
    );
  }
  

 
}






